<template>
	<div class="w-100 p-3 shadow bg-white border-15 h-center">
		<div style="width: 75%; max-width: 500px;">
			<p v-if="$localStorage.get('user').username.role==1">
				نام کاربری در صفحه ورود کاربر همان شماره تماس است
			</p>
			<p v-if="$localStorage.get('user').username.role==2">
				نام کاربری در صفحه ورود استاد همان  شماره تماس است
			</p>
			<div class="container">
				<div class="row">
					<div class="col-sm p-0">
						<textInput
							@inputTxtFunc = "cFunc"
							label="رمز عبور فعلی"
							:val="val.c"
						/>
					</div>
					<div class="col-sm pl-0" style="display: flex; align-items: flex-end;" v-if="!send">
						<btn
							class="w-100 float-left"
							textClass="w-100"
							text="ارسال رمز عبور فعلی"
							@clickMe="send_sms()"
						/>
					</div>
				</div>
			</div>
			
			
			<textInput
				@inputTxtFunc = "pFunc"
				label="کلمه عبور جدید"
				:val="val.p"
			/>
			<textInput
				@inputTxtFunc = "p1Func"
				label="تکرار کلمه عبور جدید"
				:val="val.p1"
			/>
			<btn
				class="pt-3 w-100"
				textClass="w-100"
				text="ذخیره"
				@clickMe="sav()"
			/>
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		import textInput from  "../../UI/input/textInput.vue";
		import selectInput from  "../../UI/input/selectInput.vue";
		import userImg from  "../../UI/userImg/userImg.vue";
		import pageNavigation from  "../../UI/pageNavigation/pageNavigation.vue";
		import previewImage from  "../../UI/uploadFile/previewImage.vue";

		export default {
			name: 'self_part1',
			data(){
				return {
					send: false,					
					location: {ok: false, data: []},
					degrees: {ok: false, data: []},
					field: {ok: false, data: []},
					username: [],
					random_number:"",
					val:{
						c: '',
						p: '',
						p1: '',
					}
				}
			},
			components: {
				btn,
				textInput,
				selectInput,
				pageNavigation,
				userImg,
				previewImage,
			},
			props: {
				flds: {
					default: [],
				},
			},
			mounted(){

			},
			methods:{
				stringToBase64(str) {
					let encodedStr = encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
						(match, p1) => String.fromCharCode('0x' + p1)
					);
					return btoa(encodedStr);
				},
				//*************************************************************
				send_sms(){	
					this.send = true;				
					this.random_number = Math.floor(Math.random()*10).toString() + Math.floor(Math.random()*10).toString()+ Math.floor(Math.random()*10).toString()+ Math.floor(Math.random()*10).toString();
					var txt = `مدرس / کاربر گرامی؛ \n رمز عبور فعلی شما برابر: \n` + this.random_number+'\n \n ticket.siadat.net';
					txt = this.stringToBase64(this.stringToBase64(txt));
			window.$.post(window.sendSms, {token: this.$localStorage.get("user"), phn: this.$localStorage.get("user").username.mobile, txt: txt }, function(){
				}, "json");
				},
				//______________________________________________________________________
				sav(THIS = this){
					if(this.val.p == '' || this.val.p1 == '' || this.val.c == ''){
						this.$swal.fire({
							position: 'center',
							type: 'error',
							title: "تمام قسمت ها را تکمیل نمایید",
							showCloseButton: true,
							showCancelButton: false,
							showConfirmButton: false,
							timer: 2000,
						})
					} else if(this.val.p != this.val.p1){
						this.$swal.fire({
							position: 'center',
							type: 'error',
							title: "کلمات عبور برابر نیستند",
							showCloseButton: true,
							showCancelButton: false,
							showConfirmButton: false,
							timer: 2000,
						})
					} else if(this.random_number != this.val.c){
						this.$swal.fire({
							position: 'center',
							type: 'error',
							title: "رمز عبور فعلی اشتباه است",
							showCloseButton: true,
							showCancelButton: false,
							showConfirmButton: false,
							timer: 2000,
						})
					}else{
						let url = (this.$localStorage.get('user').username.role==1) ? 'account/step_user_pass' : 'accountTeacher/step_teacher_pass';
						window.$.post(window.baseurl+url, {
							token: this.$localStorage.get("user"),
							id: this.$localStorage.get("user").username.id,
							val: this.val.p,
						}, function(D){
							THIS.$swal.fire({
							position: 'center',
							type: 'success',
							title: "ثبت شد",
							showCloseButton: true,
							showCancelButton: false,
							showConfirmButton: false,
							timer: 2000,
						})
						}, "json");
					}
				},
				//______________________________________________________________________
				cFunc(e){ this.val.c=e; },
				//______________________________________________________________________
				pFunc(e){ this.val.p=e; },
				//______________________________________________________________________
				p1Func(e){ this.val.p1=e; },
				//______________________________________________________________________
			}
		}
	</script>
<style>

</style>
